type LocalStorageKeys = 'HEADER_NAME' | 'USER_TOKEN'

export const localStorageKeys: Record<LocalStorageKeys, string> = {
  HEADER_NAME: 'HEADER_NAME',
  USER_TOKEN: 'USER_TOKEN'
}
